export default "__VITE_ASSET__DQwHdqYq__"